import React, { FunctionComponent } from "react";
import { Demo } from "../components/demo";

const contentAreaCode = `<ContentArea>
    <WorkItemNavigation>
        <span>Work item content</span>
    </WorkItemNavigation>
    <Toolbar>
        <span>Toolbar content</span>
    </Toolbar>
    <Workspace>
        <span>Workspace content</span>
    </Workspace>
    <ContextualToolbar>
        <span>Contextual toolbar content</span>
    </ContextualToolbar>
</ContentArea>`;

const contentAreaDemo = {
    code: contentAreaCode
};

export const ContentAreaDemo: FunctionComponent = ({ children }) => {
    return <Demo demo={contentAreaDemo}>{children}</Demo>;
};
